module.exports = __webpack_public_path__ + "static/media/uber-wordmark.b4d1c5bb.svg";